import { render } from "./ObjectLoop.vue?vue&type=template&id=2e3952e2"
import script from "./ObjectLoop.vue?vue&type=script&lang=js"
export * from "./ObjectLoop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__